module.exports = __webpack_public_path__ + "static/media/berserk_effect.d1351d9c.png";